import { CallWithAuth } from '../actions/apiAction';

/** Session cache for My Subscribers dashboard metrics. */
let cached = null; // { data, at, version }
let inflight = null;

const TTL_MS = 5 * 60 * 1000;
/** Bump when response shape changes. */
const CACHE_VERSION = 3;

function mapDurationPair(duration_res) {
  return [
    {
      mode: 'Voice',
      avg: Number(duration_res?.voice.avg_min) || 0,
      longest_min: Number(duration_res?.voice.longest_min) || 0,
    },
    {
      mode: 'Video',
      avg: Number(duration_res?.video.avg_min) || 0,
      longest_min: Number(duration_res?.video.longest_min) || 0,
    },
  ];
}

async function fetchSubscribersBundle() {
  const [
    summaryRes,
    dailySeriesRes,
    // signupsRes,
    modalityRes,
    usersRes,
    engagementRes,
    durationRes,
    // videoDurationRes,
  ] = await Promise.all([
    CallWithAuth('GET', '/creator-dashboard/metrics/summary'),
    CallWithAuth('GET', '/creator-dashboard/metrics/engagement/daily-series'),
    // CallWithAuth('GET', '/creator-dashboard/metrics/engagement/daily-series-signups'),
    CallWithAuth('GET', '/creator-dashboard/metrics/engagement/modality-mix'),
    CallWithAuth('GET', '/creator-dashboard/users/stats'),
    CallWithAuth('GET', '/creator-dashboard/metrics/engagement/message-counts'),
    CallWithAuth('GET', '/creator-dashboard/metrics/reliability/duration'),
    // CallWithAuth('GET', '/creator-dashboard/metrics/reliability/duration?mode=video'),
  ]);

  const signupTrend = (dailySeriesRes?.data || []).map((item) => ({
    day: item?.day,
    subscribers: item?.new_subscribers,
    new_users: item?.new_users,
  }));

  // const usersTrend = (signupsRes?.data || []).map((item) => ({
  //   day: item?.day,
  //   signups: item?.new_users,
  // }));
  return {
    summary: summaryRes?.data ?? null,
    signupTrend,
    // usersTrend,
    modalityMixdata: modalityRes?.data ?? [],
    users: usersRes?.data ?? [],
    engagement: engagementRes?.data ?? null,
    sessionDuration: mapDurationPair(durationRes?.data) ?? [],
  };
}

export function peekSubscribersMetrics() {
  if (
    cached?.data &&
    cached.version === CACHE_VERSION &&
    Date.now() - cached.at < TTL_MS
  ) {
    return cached.data;
  }
  return null;
}

/**
 * Return cached subscribers metrics or fetch (deduped).
 * @param {{ force?: boolean }} [opts]
 */
export async function getSubscribersMetrics({ force = false } = {}) {
  if (!force) {
    const hit = peekSubscribersMetrics();
    if (hit) return hit;
    if (inflight) return inflight;
  }

  inflight = (async () => {
    const data = await fetchSubscribersBundle();
    cached = { data, at: Date.now(), version: CACHE_VERSION };
    return data;
  })();

  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

/** Prefetch on dashboard load — non-blocking. */
export function warmSubscribersMetrics() {
  getSubscribersMetrics().catch((err) => {
    console.warn('Subscribers prefetch failed', err);
  });
}

export function clearSubscribersCache() {
  cached = null;
  inflight = null;
}
